import { darken, lighten } from "@mui/material";
import _ from "lodash";
import moment from "moment";

export const invertColor = (hex, bw) => {
	if (hex == null || hex.length < 3) {
		return;
	}
	if (hex.indexOf('#') === 0) {
		hex = hex.slice(1);
	}
	// convert 3-digit hex to 6-digits.
	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}
	if (hex.length !== 6) {
		throw new Error('Invalid HEX color.');
	}
	var r = parseInt(hex.slice(0, 2), 16),
		g = parseInt(hex.slice(2, 4), 16),
		b = parseInt(hex.slice(4, 6), 16);
	if (bw) {
		// https://stackoverflow.com/a/3943023/112731
		return (r * 0.299 + g * 0.587 + b * 0.114) > 186
			? '#000000'
			: '#FFFFFF';
	}
	// invert color components
	r = (255 - r).toString(16);
	g = (255 - g).toString(16);
	b = (255 - b).toString(16);
	// pad each with zeros and return
	return "#" + padZero(r) + padZero(g) + padZero(b);
}

export const lighter = (colour, coefficient, theme) => {
	if (!colour) {
		return null;
	}
	if (theme?.palette?.mode == 'dark') {
		return darken(colour, coefficient);
	}
	return lighten(colour, coefficient);
	// return colour + '33';
};

export const padZero = (str, len) => {
	len = len || 2;
	var zeros = new Array(len).join('0');
	return (zeros + str).slice(-len);
};

Array.prototype.naturalSort = function (property) {
	var a, b, a1, b1, rx = /(\d+)|(\D+)/g, rd = /\d+/;
	return this.sort(function (as, bs) {
		a = String(as[property]).toLowerCase().match(rx);
		b = String(bs[property]).toLowerCase().match(rx);
		while (a.length && b.length) {
			a1 = a.shift();
			b1 = b.shift();
			if (rd.test(a1) || rd.test(b1)) {
				if (!rd.test(a1)) return 1;
				if (!rd.test(b1)) return -1;
				if (a1 != b1) return a1 - b1;
			}
			else if (a1 != b1) return a1 > b1 ? 1 : -1;
		}
		return a.length - b.length;
	});
};

Array.prototype.alphanumSort = function (property, caseInsensitive) {
	for (var z = 0, t; t = this[z]; z++) {
		this[z] = [];
		var x = 0, y = -1, n = 0, i, j;

		while (i = (j = t.charAt(x++)).charCodeAt(0)) {
			var m = (i == 46 || (i >= 48 && i <= 57));
			if (m !== n) {
				this[z][++y] = "";
				n = m;
			}
			this[z][y] += j;
		}
	}

	this.sort(function (a, b) {
		for (var x = 0, aa, bb; (aa = a[x]) && (bb = b[x]); x++) {
			if (caseInsensitive) {
				aa = aa.toLowerCase();
				bb = bb.toLowerCase();
			}
			if (aa !== bb) {
				var c = Number(aa), d = Number(bb);
				if (c == aa && d == bb) {
					return c - d;
				} else return (aa > bb) ? 1 : -1;
			}
		}
		return a.length - b.length;
	});

	for (var z = 0; z < this.length; z++)
		this[z] = this[z].join("");
};

export const getInterpolatedColor = (value, min, max) => {
	// Normalize value between 0 and 1
	let normalized = (value - min) / (max - min);

	let red = [211, 47, 47];
	let yellow = [249, 248, 113];
	let green = [46, 125, 50];

	let color;
	if (normalized < 0.5) {
		// Interpolate between red and yellow
		let factor = normalized * 2;
		color = red.map((c, i) => Math.round(c + factor * (yellow[i] - c)));
	} else {
		// Interpolate between yellow and green
		let factor = (normalized - 0.5) * 2;
		color = yellow.map((c, i) => Math.round(c + factor * (green[i] - c)));
	}

	// Convert to hex format
	return `rgb(${color[0]},${color[1]},${color[2]})`;
}

export const isSamePageLinkNavigation = (event) => {
	if (
		event.defaultPrevented ||
		event.button !== 0 || // ignore everything but left-click
		event.metaKey ||
		event.ctrlKey ||
		event.altKey ||
		event.shiftKey
	) {
		return false;
	}
	return true;
}

export const onModelChange = (obj, e, key) => {
	const changed = { ...obj };
	let value = e?.target ? e.target.value : e;
	if (e?.target?.type == 'checkbox') {
		value = value == 'on';
	}

	value = value instanceof moment ? value.valueOf() : value;
	changed[key] = value;
	return changed;
}

export const inputChange = (input, value) => {
	const prototype = Object.getPrototypeOf(input);
	const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
		prototype,
		'value'
	).set;

	nativeInputValueSetter.call(input, value);

	input.dispatchEvent(
		new Event('input', { bubbles: true })
	);
}

export const getRangeLabel = (startDate, endDate, yearFormat = 'YYYY', monthFormat = 'MMMM', dateFormat = 'D') => {
	let dateLabel = null;
	if (startDate) {
		const now = moment();
		const start = moment(startDate);
		const sameYear = start.isSame(now, 'year');
		if (endDate) {
			const end = moment(endDate);
			if (start.isSame(end, 'year')) {
				if (start.isSame(end, 'month')) {
					dateLabel = start.format(monthFormat + ' ' + dateFormat) + ' - ' + end.format(dateFormat + (sameYear ? '' : ', YYYY'));
				}
				else {
					dateLabel = start.format(monthFormat + ' ' + dateFormat) + ' - ' + end.format(monthFormat + ' ' + dateFormat + (sameYear ? '' : ', ' + yearFormat));
				}
			}
			else {
				dateLabel = start.format(monthFormat + ' ' + dateFormat + (sameYear ? '' : ', ' + yearFormat)) + ' - ' + end.format(monthFormat + ' ' + dateFormat + ', ' + yearFormat);
			}
		}
		else {
			dateLabel = start.format(monthFormat + ' ' + dateFormat + ', YYYY');
		}
	}
	return dateLabel;
}

export const toListNumbering = (num, format) => {
	switch(format){
		case 'A': return toBase26(num);
		case 'a': return toBase26(num).toLowerCase();
		case 'I': return toRomanNumeral(num);
		case 'i': return toRomanNumeral(num).toLowerCase();
		default: return num;
	}
}

export const toBase26 = (num) => {
	if (isNaN(num)) {
		return NaN;
	}
	let result = '';
	num--;
	while (num >= 0) {
		const remainder = num % 26;
		result = String.fromCharCode(65 + remainder) + result;
		num = Math.floor(num / 26) - 1;
	}
	return result;
}

export const toRomanNumeral = (num) => {
	if (isNaN(num)) {
		return NaN;
	}
	var digits = String(+num).split(""),
		key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
			"", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
			"", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
		roman = "",
		i = 3;
	while (i--) {
		roman = (key[+digits.pop() + (i * 10)] || "") + roman;
	}
	return Array(+digits.join("") + 1).join("M") + roman;
}

export const isCourseActive = (course) => {
	if( course?.enrollments?.length ){
		for( const enrollment of course.enrollments ){
			if( enrollment.startDate && enrollment.endDate ){
				const now = new Date().getTime();
				if( enrollment.startDate <= now && enrollment.endDate >= now ){
					return true;
				}
			}
		}
	}
	return false;
};